<template>
  <div class="content">

     <b-card>
      <b-row>
        <b-col>
          <b-img v-bind:src="emod_img" alt="placeholder" style="min-width:400px;max-width:100%;"></b-img>
        </b-col>
        <b-col md="12" lg="7">
          Here is the dataset used in the following paper.
          Shen, S. Fan, Y. Wong, T.-T. Ng and M. Kankanhalli, "Human-imperceptible Privacy Protection Against Machines". ACM Multimedia Conference (ACMMM), 2019.  
          <br>
          <h3> EMOd dataset </h3>
          S. Fan, Z. Shen, M. Jiang, B. Koenig, J. Xu, M. Kankanhali, Q.Zhao, "Emotional Attention: A Study of Image Sentiment and Visual Attention ", IEEE Conference on Computer Vision and Pattern Recognition (CVPR), 2018. (<span style="color:red">Spotlight oral, acceptance rate: 6.6%</span>)[<a href="https://ncript.comp.nus.edu.sg/site/ncript-top/emotionalattention/">website</a>]
        </b-col>
      </b-row>

      <br>  
      <strong>Image Stimuli:</strong> <a href="https://ncript.comp.nus.edu.sg/site/nus-files/emotionattention/CVPR2018/EMOdImages1019.zip">1019 Images</a> (82.3 MB) 
      [<a href="javascript:;" v-b-toggle.collapse-1>Examples</a>]
      <b-collapse id="collapse-1" class="mt-2">
        Examples of image stimuli:
        <b-card>
          <b-row>
            <b-col>
              <b-img v-bind:src="stimuli1" style="min-width:300px;max-width:100%;" alt="placeholder"></b-img>
            </b-col>
            <b-col>
              <b-img v-bind:src="stimuli2" style="min-width:300px;max-width:100%;" alt="placeholder"></b-img>
            </b-col>
            <b-col>
              <b-img v-bind:src="stimuli3" style="min-width:300px;max-width:100%;" alt="placeholder"></b-img>
            </b-col>
          </b-row>
        </b-card>
      </b-collapse>
      
      <br>
      <strong>Fixation Maps (continuous and binary):</strong> <a href="https://ncript.comp.nus.edu.sg/site/nus-files/emotionattention/CVPR2018/FixationMap.zip">1019 Images</a> (13.7 MB)
      [<a href="javascript:;" v-b-toggle.collapse-2>Examples</a>]

      <b-collapse id="collapse-2" class="mt-2">
        <b-card>
          Original Images:
          <b-row>
            <b-col>
              <b-img v-bind:src="stimuli1" style="min-width:300px;max-width:100%;" alt="placeholder"></b-img>
            </b-col>
            <b-col>
              <b-img v-bind:src="stimuli2" style="min-width:300px;max-width:100%;" alt="placeholder"></b-img>
            </b-col>
            <b-col>
              <b-img v-bind:src="stimuli3" style="min-width:300px;max-width:100%;" alt="placeholder"></b-img>
            </b-col>
          </b-row>

          Examples of Continuous Map:
          <b-row>
            <b-col>
              <b-img v-bind:src="continuous1" style="min-width:300px;max-width:100%;" alt="placeholder"></b-img>
            </b-col>
            <b-col>
              <b-img v-bind:src="continuous2" style="min-width:300px;max-width:100%;" alt="placeholder"></b-img>
            </b-col>
            <b-col>
              <b-img v-bind:src="continuous3" style="min-width:300px;max-width:100%;" alt="placeholder"></b-img>
            </b-col>
          </b-row>

          Examples of Binary Map:
          <b-row>
            <b-col>
              <b-img v-bind:src="binary1" style="min-width:300px;max-width:100%;" alt="placeholder"></b-img>
            </b-col>
            <b-col>
              <b-img v-bind:src="binary2" style="min-width:300px;max-width:100%;" alt="placeholder"></b-img>
            </b-col>
            <b-col>
              <b-img v-bind:src="binary3" style="min-width:300px;max-width:100%;" alt="placeholder"></b-img>
            </b-col>
          </b-row>
        </b-card>
      </b-collapse>

    <br>
    <strong>Sensitivity Maps:</strong> <a href="https://ncript.comp.nus.edu.sg/site/nus-files/visual-privacy/sensitivity_map.zip">773 Images</a> (without IAPS) (6.5 MB)
    [<a href="javascript:;" v-b-toggle.collapse-3>Examples</a>]
      <b-collapse id="collapse-3" class="mt-2">
        
        <b-card>
          Original Images:
          <b-row>
            <b-col>
              <b-img v-bind:src="stimuli1" style="min-width:300px;max-width:100%;" alt="placeholder"></b-img>
            </b-col>
            <b-col>
              <b-img v-bind:src="stimuli2" style="min-width:300px;max-width:100%;" alt="placeholder"></b-img>
            </b-col>
            <b-col>
              <b-img v-bind:src="stimuli3" style="min-width:300px;max-width:100%;" alt="placeholder"></b-img>
            </b-col>
          </b-row>
          Examples of sensitivity map:
          <b-row>
            <b-col>
              <b-img v-bind:src="sensitivity1" style="min-width:300px;max-width:100%;" alt="placeholder"></b-img>
            </b-col>
            <b-col>
              <b-img v-bind:src="sensitivity2" style="min-width:300px;max-width:100%;" alt="placeholder"></b-img>
            </b-col>
            <b-col>
              <b-img v-bind:src="sensitivity3" style="min-width:300px;max-width:100%;" alt="placeholder"></b-img>
            </b-col>
          </b-row>
        </b-card>
      </b-collapse>

      <br>
     
      
          
      <strong>Raw Eye-tracking Data:</strong> <a href="https://ncript.comp.nus.edu.sg/site/nus-files/emotionattention/CVPR2018/fixations1019_renamed.mat">MATLAB mat</a> (2.3 MB)<br>
      <strong>Labelled Object Contours and Attributes:</strong> <a href="https://ncript.comp.nus.edu.sg/site/nus-files/emotionattention/CVPR2018/AllLabelData1019.mat">MATLAB mat</a> (776 KB)<br>
      <strong>Image-level Annotation:</strong> <a href="https://ncript.comp.nus.edu.sg/site/nus-files/emotionattention/CVPR2018/allfindata1019_renamed.mat">MATLAB mat</a> (64 KB)<br>

    </b-card>
  </div>
</template>

<script>


export default {
  name: 'Dataset',
  data(){
    return {
      emod_img: require('../assets/emod.jpg'),

      stimuli1: require('../assets/stimuli/0020.jpg'),
      stimuli2: require('../assets/stimuli/0339.jpg'),
      stimuli3: require('../assets/stimuli/0350.jpg'),

      continuous1: require('../assets/fixation/continuous/0020.jpg'),
      continuous2: require('../assets/fixation/continuous/0339.jpg'),
      continuous3: require('../assets/fixation/continuous/0350.jpg'),

      binary1: require('../assets/fixation/binary/0020.jpg'),
      binary2: require('../assets/fixation/binary/0339.jpg'),
      binary3: require('../assets/fixation/binary/0350.jpg'),

      sensitivity1: require('../assets/sensitivity/0020_sensitivity.jpg'),
      sensitivity2: require('../assets/sensitivity/0339_sensitivity.jpg'),
      sensitivity3: require('../assets/sensitivity/0350_sensitivity.jpg')
    }
  },
  components:{
  }
}
</script>

<style scoped>

</style>
